export default function KitCard({ kit, isSelected, onSelect }) {
  const productCount = Array.isArray(kit.products) ? kit.products.length : 0;

  return (
    <button
      onClick={() => onSelect(kit)}
      className={`p-3 rounded-lg border-2 text-left transition-all duration-150 hover:shadow-md
        ${isSelected
          ? 'border-blue-500 bg-blue-50 ring-2 ring-blue-200'
          : 'border-gray-200 bg-white hover:border-blue-300'}`}
    >
      <div className="font-semibold text-sm text-gray-800 truncate">{kit.name}</div>
      <div className="text-xs text-gray-500 mt-1">{productCount} productos</div>
    </button>
  );
}
